import type { Run, UserRole } from '@/types/database'

/** The tenant roles correct_run_variety admits (mig 20261090000000, UF-07):
 *  ADMIN, SUPER_ADMIN, MANAGER on the active tenant, plus has_perm('runs','edit'). */
const CHANGE_FRUIT_ROLES: ReadonlySet<string> = new Set(['ADMIN', 'SUPER_ADMIN', 'MANAGER'])

/**
 * Should a run offer "Change fruit"? Mirrors the RPC's own refusals for the cases
 * the screen already knows (role, permission, status, kind, nothing tipped or
 * packed) so the button is not offered just to be refused. The server stays the
 * boundary: it also refuses a run holding bins, QC, rejects or tokens, which the
 * screen cannot see from the run row.
 *
 * `role` is the TENANT role (`tenantRoleOf(me)`), never the global one: the RPC
 * reads current_tenant_role(). A platform admin in platform view counts as admin,
 * as the RPC admits a platform admin.
 */
export function canChangeRunFruit(input: {
  role: UserRole | string | null | undefined
  canEditRuns: boolean
  run: Pick<Run, 'status' | 'tipped_net_weight_kg' | 'pallet_count'> & { run_kind?: string | null }
  inPlatformView?: boolean
}): boolean {
  const { role, canEditRuns, run, inPlatformView = false } = input
  const roleOk = inPlatformView || (role != null && CHANGE_FRUIT_ROLES.has(role))
  if (!roleOk || !canEditRuns) return false
  if (run.status !== 'ACTIVE') return false
  if ((run.run_kind ?? 'PACK') === 'EXTERNAL_RECEIPT') return false
  return Number(run.tipped_net_weight_kg ?? 0) === 0 && Number(run.pallet_count ?? 0) === 0
}
